import { useState, useRef } from "react";
import PropTypes from "prop-types";
import UIWidgetsCheckbox from "./Checkbox";
import CustomCheckbox from "./custom";

export default function Checkbox({
  id, name, defaultChecked = false, checked: checkedProp, disabled,
  onFocus = () => {}, onBlur = () => {}, onChange = () => {}, onClick,
  tabIndex, readOnly, autoFocus, value, custom, background, dataTestId, handleOnClick
}) {
  // Derived state: if controlled (checkedProp provided), use it; else use internal state
  const isControlled = checkedProp !== undefined;
  const [internalChecked, setInternalChecked] = useState(
    isControlled ? checkedProp : defaultChecked
  );
  const saveInput = useRef(null);

  const checked = isControlled ? checkedProp : internalChecked;

  const handleChange = (e) => {
    if (disabled) return;
    if (!isControlled) {
      setInternalChecked(e.target.checked);
    }
    e.stopPropagation();
    onChange({
      target: {
        id, name, defaultChecked, checked: checkedProp, disabled,
        tabIndex, readOnly, autoFocus, value, custom, background, dataTestId, handleOnClick,
        checked: e.target.checked
      }
    });
  };

  const handleClick = () => {
    if (handleOnClick) handleOnClick();
  };

  const sharedProps = {
    id, name, readOnly, disabled, tabIndex,
    checked: !!checked,
    onFocus, onBlur,
    onChange: handleChange,
    onClick: handleClick,
    autoFocus,
    ref: saveInput,
    value
  };

  return custom ? (
    <CustomCheckbox {...sharedProps} background={background} data-testid={dataTestId} />
  ) : (
    <UIWidgetsCheckbox {...sharedProps} data-testid={dataTestId} />
  );
}

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  defaultChecked: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  checked: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  disabled: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  value: PropTypes.any,
  dataTestId: PropTypes.string,
  custom: PropTypes.bool,
  background: PropTypes.string,
};